import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function TarifeManopera() {
  const [firma, setFirma] = useState(null);
  const [rates, setRates] = useState({ tarif_skill1: "", tarif_skill2: "" });
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let active = true;
    authFetch("/firma").then(data => {
      if (!active) return;
      const item = data.items?.[0];
      if (!item?.bxid) throw new Error("Firma nu a putut fi încărcată.");
      setFirma(item.bxid);
      setRates({ tarif_skill1: item.tarif_skill1 ?? 0, tarif_skill2: item.tarif_skill2 ?? 0 });
    }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  const save = async event => {
    event.preventDefault();
    const payload = Object.fromEntries(Object.entries(rates).map(([key, value]) => [key, Number(value)]));
    if (Object.values(rates).some(value => value === "") || Object.values(payload).some(value => !Number.isFinite(value) || value < 0)) {
      setError("Completează tarife pozitive sau zero."); return;
    }
    setSaving(true); setError(""); setNotice("");
    try {
      await authFetch(`/firma/${firma}`, { method: "PUT", body: JSON.stringify(payload) });
      setNotice("Tarifele au fost salvate. Se folosesc la următoarea alegere a unei operații în deviz.");
    } catch (err) { setError(err.message || "Tarifele nu au putut fi salvate."); }
    finally { setSaving(false); }
  };
  return <Form onSubmit={save} className="border rounded p-3 mb-4">
    <h5>Tarife pe Skill</h5>
    <p className="text-muted">Prețuri în lei/oră, fără TVA. Valoare manoperă = ore normate × tarif Skill.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {notice && <Alert variant="success">{notice}</Alert>}
    <Row className="g-3 align-items-end">
      {[["tarif_skill1", "1 — Ușoară"], ["tarif_skill2", "2 — Complicată"]].map(([key, label]) =>
        <Col md={4} key={key}><Form.Group controlId={key}>
          <Form.Label>{label} (lei/oră)</Form.Label>
          <Form.Control type="number" min="0" step="0.01" required disabled={!firma || saving} value={rates[key]}
            onChange={event => { setRates(prev => ({ ...prev, [key]: event.target.value })); setNotice(""); }} />
        </Form.Group></Col>)}
      <Col><Button type="submit" disabled={!firma || saving}>{saving ? "Se salvează…" : "Salvează tarife"}</Button></Col>
    </Row>
  </Form>;
}
